import { render, staticRenderFns } from "./SAIFFooter.vue?vue&type=template&id=5db6bf7e&scoped=true"
import script from "./SAIFFooter.vue?vue&type=script&lang=js"
export * from "./SAIFFooter.vue?vue&type=script&lang=js"
import style0 from "./SAIFFooter.vue?vue&type=style&index=0&id=5db6bf7e&prod&lang=css"
import style1 from "./SAIFFooter.vue?vue&type=style&index=1&id=5db6bf7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db6bf7e",
  null
  
)

export default component.exports